// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../../../node_modules/postcss-loader/dist/cjs.js!../../../../components/library/style/colors.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.kwXX6QYpqDjyFqSRA0Pz {
    margin: 0;
    font-size: 24px;
}

.QKRIfy_D1RLW8oNfukGM {
    color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-text-subtle"]};
    margin-top: 8px;
}

.MZhtwi0BEWQS5KEsh2O3 {
    margin-bottom: 32px;
}
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/DashboardOpportunity/DashboardOpportunityLayout/DashboardOpportunityLayout.module.css"],"names":[],"mappings":"AAGA;IACI,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,mDAAwB;IACxB,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB","sourcesContent":["@value colors: \"../../../../components/library/style/colors.css\";\n@value color-text-subtle, color-error from colors;\n\n.title {\n    margin: 0;\n    font-size: 24px;\n}\n\n.description {\n    color: color-text-subtle;\n    margin-top: 8px;\n}\n\n.layout {\n    margin-bottom: 32px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"colors": `"../../../../components/library/style/colors.css"`,
	"color-text-subtle": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-text-subtle"]}`,
	"color-error": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-error"]}`,
	"title": `kwXX6QYpqDjyFqSRA0Pz`,
	"description": `QKRIfy_D1RLW8oNfukGM`,
	"layout": `MZhtwi0BEWQS5KEsh2O3`
};
export default ___CSS_LOADER_EXPORT___;
